export default __webpack_public_path__ + "static/media/eva_ste_catherine.de70e92a.jpg";